// AiCalendarTimelineProvider.jsx — scoped calendar/timeline sub-view state for AI surfaces

import React, { useMemo } from 'react';

// Context
import { CalendarTimelineProvider } from 'context/CalendarTimelineContext';

const normalizeViewType = (value) => String(value || '').trim().toUpperCase();

const AiCalendarTimelineProvider = React.memo(({
  view,
  children,
}) => {
  const viewType = normalizeViewType(view?.type);
  const initialCalendarViewType = viewType === 'CALENDAR'
    ? normalizeViewType(view?.calendarSubView) || 'AGENDA'
    : 'MONTH';
  const initialTimelineViewType = viewType === 'TIMELINE'
    ? normalizeViewType(view?.timelineScale) || 'WEEK'
    : 'WEEK';
  // ----- MEMOS ----- //

  const initialSelectedDate = React.useMemo(() => {
    const windowStartMs = Number(view?.scheduleWindow?.windowStartMs);
    if (!Number.isFinite(windowStartMs) || windowStartMs <= 0) return null;
    const date = new Date(windowStartMs);
    return Number.isNaN(date.getTime()) ? null : date;
  }, [view?.scheduleWindow?.windowStartMs]);

  const providerKey = useMemo(() => (
    `${viewType}:${initialCalendarViewType}:${initialTimelineViewType}:${view?.key || ''}:${initialSelectedDate?.getTime?.() || ''}`
  ), [initialCalendarViewType, initialSelectedDate, initialTimelineViewType, view?.key, viewType]);

  // ----- RENDER ----- //

  return (
    <CalendarTimelineProvider
      key={providerKey}
      initialCalendarViewType={initialCalendarViewType}
      initialTimelineViewType={initialTimelineViewType}
      initialSelectedDate={initialSelectedDate}
    >
      {children}
    </CalendarTimelineProvider>
  );
});

// Dev Tools
AiCalendarTimelineProvider.displayName = 'AiCalendarTimelineProvider';

export default AiCalendarTimelineProvider;
